//@flow
import { connect } from 'react-redux';
import NewPaymentMeanPage from './NewPaymentMeanPage';
import { isLoadingSelector } from '../../../modules/LoadingStatus/reducer';
import { paymentMeanSelector } from '../../../modules/Payment/selector';

const mapStateToProps = state => ({
  isConfirmingPayment: isLoadingSelector(state, 'confirmPayment'),
  paymentInfo: paymentMeanSelector(state),
});

export default connect(mapStateToProps)(NewPaymentMeanPage);
